import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import VerifiedIcon from "@mui/icons-material/Verified";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

export default function ArtificialIntelligence() {
  return (
    <Box sx={{ backgroundColor: "#1f2937", color: "#e5e7eb" }}>
      {/* ================= HERO ================= */}
      <Box sx={{ py: 12 }}>
        <Container>
          <Typography
            variant="h3"
            align="center"
            fontWeight={600}
            gutterBottom
          >
            Artificial Intelligence
          </Typography>

          <Typography
            align="center"
            sx={{ maxWidth: 900, mx: "auto", opacity: 0.9 }}
          >
            At NerdsHub, we specialize in turning the complex world of artificial
            intelligence into accessible, powerful tools that drive innovation,
            efficiency, and growth for your business.
          </Typography>

          {/* Tabs */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            mt={6}
          >
            <Button sx={tab}>
              Machine Learning & Deep Learning
            </Button>
            <Button sx={tab}>Natural Language Processing (NLP)</Button>
            <Button sx={tab}>Computer Vision</Button>
            <Button sx={tab}>RPA</Button>
          </Stack>

          <Divider sx={{ mt: 3, borderColor: "#374151" }} />
        </Container>
      </Box>

      {/* ================= ML SECTION ================= */}
      <Container sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              Machine Learning & Deep Learning
            </Typography>

            <Typography sx={{ mb: 3, opacity: 0.9 }}>
              We create intelligent systems that learn from data, improve over
              time, and make decisions with minimal human intervention.
            </Typography>

            <Typography sx={{ opacity: 0.85 }}>
              From predictive analytics to image and speech recognition, our AI
              solutions are designed to increase accuracy, efficiency, and
              business impact.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71"
              alt="AI Analytics"
              sx={{
                width: "100%",
                borderRadius: 3,
                boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* ================= WHY CHOOSE US ================= */}
      <Box sx={{ backgroundColor: "#111827", py: 12 }}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight={600}
          >
            Why Choose NerdsHub for AI Development?
          </Typography>

          <Grid container spacing={8} mt={4}>
            {/* Left Image */}
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://images.unsplash.com/photo-1520607162513-77705c0f0d4a"
                alt="AI Business"
                sx={{
                  width: "100%",
                  borderRadius: 3,
                }}
              />
            </Grid>

            {/* Right Content */}
            <Grid item xs={12} md={6}>
              <Feature
                icon={<PsychologyIcon />}
                title="Customized AI Solutions"
                desc="We design AI systems tailored to your specific business needs, ensuring scalability, performance, and security."
              />

              <Feature
                icon={<AutoAwesomeIcon />}
                title="End-to-End Support"
                desc="From ideation and development to deployment and optimization, our experts guide you at every stage."
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ================= ETHICS & TECHNOLOGY ================= */}
      <Container sx={{ py: 12 }}>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
             src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=1200&q=80"
              alt="Ethical AI"
              sx={{ width: "100%", borderRadius: 3 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Feature
              icon={<VerifiedIcon />}
              title="Ethical AI"
              desc="We follow strict ethical standards, ensuring fairness, transparency, data privacy, and regulatory compliance."
            />

            <Feature
              icon={<PrecisionManufacturingIcon />}
              title="Cutting-Edge Technology"
              desc="We continuously evolve with the AI landscape, leveraging the latest frameworks, tools, and research."
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

/* ================= REUSABLE COMPONENT ================= */

function Feature({ icon, title, desc }) {
  return (
    <Box sx={{ display: "flex", mb: 5 }}>
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          backgroundColor: "#ec4899",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 3,
          color: "#fff",
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ opacity: 0.85 }}>{desc}</Typography>
      </Box>
    </Box>
  );
}

/* ================= STYLES ================= */


const tab = {
  color: "#9ca3af",
  textTransform: "none",
};
